import React from "react";
import { Center, Image, Text, VStack } from "@chakra-ui/react";
import eventPlaceholder from "assets/event-placeholder.png";

export const EventPlaceholder = () => {
  return (
    <Center height="100%">
      <VStack
        spacing={4}
        alignItems={"center"}
        justifyContent={"center"}
        height={"500px"}
      >
        <Image src={eventPlaceholder} alt="Event Placeholder" boxSize="50px" />
        <Text fontSize="lg" fontWeight="bold" color="gray.500">
          Select event to view details
        </Text>
      </VStack>
    </Center>
  );
};
